/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { getPartnerCount } from "../../services/partnerService";
import ttsService, { IBook, IProject } from "../../services/ttsService";
import { PARTNERS_CHANGED_EVENT } from "../../utils/dashboardStats";
import "./DashboardHome.css";
import { connectSocket, sendMessage } from "../../websockets/socket";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";

interface BookRow {
  book: IBook;
  projectId: string;
  projectName: string;
}

const StatIconProjects = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M3 7V5a2 2 0 0 1 2-2h5l2 2h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
  </svg>
);

const StatIconBooks = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

const StatIconPartners = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const bookInitial = (title: string) => (title.trim()[0] || "?").toUpperCase();
const truncateTitle = (title: string) => title.length > 20 ? title.slice(0, 20) + "…" : title;

const BOOKS_PER_PAGE = 10;

const DashboardHome = () => {
  const { role, user, partnerId } = useSelector((state: RootState) => state.auth);
  const isAdmin = role === "admin";
  const dispatch = useAppDispatch()
  const { notifications } = useAppSelector((state) => state.notifications);
  //  console.log("show redux notifications---->",notifications);



  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [projects, setProjects] = useState<IProject[]>([]);
  const [books, setBooks] = useState<BookRow[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [partnerCount, setPartnerCount] = useState<number | null>(null);
  const [partnersLoading, setPartnersLoading] = useState(false);

  const fetchPartnerCount = useCallback(async () => {
    if (!isAdmin) return;
    setPartnersLoading(true);
    try {
      const { total } = await getPartnerCount();
      setPartnerCount(total);
    } catch {
      setPartnerCount(null);
    } finally {
      setPartnersLoading(false);
    }
  }, [isAdmin]);

  useEffect(() => {
    void fetchPartnerCount();
  }, [fetchPartnerCount]);

  useEffect(() => {
    if (!isAdmin) return;
    const onPartnersChanged = () => {
      void fetchPartnerCount();
    };
    window.addEventListener(PARTNERS_CHANGED_EVENT, onPartnersChanged);
    return () => window.removeEventListener(PARTNERS_CHANGED_EVENT, onPartnersChanged);
  }, [isAdmin, fetchPartnerCount]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      setError("");
      try {
        const projectList = await ttsService.getProjects();
        if (cancelled) return;

        const rows: BookRow[] = [];
        await Promise.all(
          projectList.map(async (project) => {
            try {
              const projectBooks = await ttsService.getBooksForProject(project._id);
              projectBooks.forEach((book) => {
                rows.push({
                  book,
                  projectId: project._id,
                  projectName: project.projectName,
                });
              });
            } catch {
              // Keep dashboard usable if one project's books fail to load
            }
          }),
        );

        if (cancelled) return;

        rows.sort(
          (a, b) =>
            new Date(b.book.createdAt || 0).getTime() -
            new Date(a.book.createdAt || 0).getTime(),
        );

        setProjects(projectList);
        setBooks(rows);
      } catch {
        if (!cancelled) setError("Unable to load dashboard data. Please try again.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const totalProjects = projects.length;
  const totalBooks = books.length;

  const totalPages = Math.max(1, Math.ceil(books.length / BOOKS_PER_PAGE));

  const paginatedBooks = useMemo(() => {
    const start = (currentPage - 1) * BOOKS_PER_PAGE;
    return books.slice(start, start + BOOKS_PER_PAGE);
  }, [books, currentPage]);

  const rangeStart = books.length === 0 ? 0 : (currentPage - 1) * BOOKS_PER_PAGE + 1;
  const rangeEnd = Math.min(currentPage * BOOKS_PER_PAGE, books.length);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);







  useEffect(() => {
    connectSocket(() => {
      sendMessage({
        type: "auth",
        data: {
          userId: partnerId
        }
      });
    });

  }, []);
  // console.log("show logi user--->",partnerId);      

  // console.log("show userid---?",id); 




  return (
    <div className="dash-page">
      <header className="dash-hero">
        <div className="dash-container">
          <div className="dash-hero__inner">
            <div>
              <h1 className="dash-hero__title">Dashboard</h1>
              {/* <p className="dash-hero__sub">
                Welcome back, <strong>{displayName}</strong>
              </p> */}
            </div>
            {/* <Link to="/dashboard/create-project" className="dash-hero__btn">
              + New Project
            </Link> */}
          </div>
        </div>
      </header>

      <div className="dash-container dash-stats-wrap">
        <div className={`dash-stats${isAdmin ? " dash-stats--with-partners" : ""}`}>
          <div className="dash-stat dash-stat--projects">
            <div className="dash-stat__row">
              <span className="dash-stat__icon" aria-hidden="true">
                <StatIconProjects />
              </span>
              <span className="dash-stat__label">Total Projects</span>
            </div>
            <span className="dash-stat__value">{loading ? "—" : totalProjects}</span>
          </div>
          <div className="dash-stat dash-stat--books">
            <div className="dash-stat__row">
              <span className="dash-stat__icon" aria-hidden="true">
                <StatIconBooks />
              </span>
              <span className="dash-stat__label">Total Books</span>
            </div>
            <span className="dash-stat__value">{loading ? "—" : totalBooks}</span>
          </div>
          {isAdmin && (
            <div className="dash-stat dash-stat--partners">
              <div className="dash-stat__row">
                <span className="dash-stat__icon" aria-hidden="true">
                  <StatIconPartners />
                </span>
                <span className="dash-stat__label">Total Partners</span>
              </div>
              <span className="dash-stat__value">
                {partnersLoading || partnerCount === null ? "—" : partnerCount}
              </span>
            </div>
          )}
        </div>
      </div>

      {error && (
        <div className="dash-container">
          <div className="dash-error" role="alert">
            {error}
          </div>
        </div>
      )}

      <div className="dash-body">
        <div className="dash-container">
          <section className="dash-books">
            <div className="dash-books__head">
              <div>
                <h2 className="dash-books__title">All Books</h2>
                <p className="dash-books__meta">
                  {loading
                    ? "Loading your library…"
                    : `${books.length} book${books.length === 1 ? "" : "s"} across ${totalProjects} project${totalProjects === 1 ? "" : "s"}`}
                </p>
              </div>
              <Link to="/dashboard/create-project" className="dash-books__link">
                Go to Projects →
              </Link>
            </div>

            <div className="dash-books__content">
              {loading ? (
                <p className="dash-books__loading">Loading books…</p>
              ) : books.length === 0 ? (
                <div className="dash-books__empty">
                  <p>No books yet. Create a project and add your first book to get started.</p>
                  <Link to="/dashboard/create-project" className="dash-books__cta">
                    Create a project &amp; book
                  </Link>
                </div>
              ) : (
                <div className="dash-table-panel">
                  <table className="dash-table">
                    <thead>
                      <tr>
                        <th>Book</th>
                        <th>Project</th>
                        <th>Language</th>
                        <th>Platform</th>
                        <th>Author</th>
                        <th className="dash-table__action-col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedBooks.map(({ book, projectId, projectName }) => (
                        <tr key={book._id}>
                          <td>
                            <div className="dash-table__book">
                              <span className="dash-table__avatar" aria-hidden="true">
                                {bookInitial(book.title)}
                              </span>
                              <span
                                className="dash-table__book-title"
                                title={book.title.length > 20 ? book.title : undefined}
                              >
                                {truncateTitle(book.title)}
                              </span>
                            </div>
                          </td>
                          <td>
                            <span className="dash-tag dash-tag--project">{projectName}</span>
                          </td>
                          <td>
                            <span className="dash-tag dash-tag--lang">{book.language || "—"}</span>
                          </td>
                          <td>
                            <span className="dash-tag dash-tag--platform">{book.platform || "—"}</span>
                          </td>
                          <td className="dash-table__author">{book.author?.trim() || "—"}</td>
                          <td className="dash-table__action-col">
                            <Link
                              to={`/dashboard/create-project?project=${projectId}&book=${book._id}`}
                              className="dash-table__open"
                            >
                              Open →
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {books.length > BOOKS_PER_PAGE && (
                    <nav className="dash-pagination" aria-label="Books pagination">
                      <p className="dash-pagination__info">
                        Showing {rangeStart}–{rangeEnd} of {books.length}
                      </p>
                      <div className="dash-pagination__controls">
                        <button
                          type="button"
                          className="dash-pagination__btn"
                          disabled={currentPage <= 1}
                          onClick={() => setCurrentPage((p) => p - 1)}
                        >
                          ← Previous
                        </button>
                        <div className="dash-pagination__pages">
                          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                            <button
                              key={page}
                              type="button"
                              className={`dash-pagination__page${page === currentPage ? " dash-pagination__page--active" : ""}`}
                              aria-current={page === currentPage ? "page" : undefined}
                              onClick={() => setCurrentPage(page)}
                            >
                              {page}
                            </button>
                          ))}
                        </div>
                        <button
                          type="button"
                          className="dash-pagination__btn"
                          disabled={currentPage >= totalPages}
                          onClick={() => setCurrentPage((p) => p + 1)}
                        >
                          Next →
                        </button>
                      </div>
                    </nav>
                  )}
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome;
